import { render } from "./news_slider.vue?vue&type=template&id=7e6eb046"
import script from "./news_slider.vue?vue&type=script&lang=js"
export * from "./news_slider.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__